var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterRed1Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7477",
    "data-name": "Group 7477",
    transform: "translate(-782 -413)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_661",
    "data-name": "Ellipse 661",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(782 413)",
    fill: "#FF3535"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(788.885 419.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "M483.969,356.79l4.682,6.261-4.712,5.09H485l4.125-4.457,3.333,4.457h3.609l-4.946-6.613,4.386-4.738h-1.061l-3.8,4.1-3.07-4.1Zm1.56.781h1.658l7.321,9.789H492.85Z",
    transform: "translate(-483.94 -356.79)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterRed1Icon);
export default __webpack_public_path__ + "static/media/twitter-red1-icon.313856efd3a8b0648368c45ff8cd90b3.svg";
export { ForwardRef as ReactComponent };